import banner from '../../Assets/Images/cardBannerSample.png';
import demBanner from '../../Assets/Images/demBanner.jpg';
import gscmbanner from '../../Assets/Images/gscmBanner.jpg';

export const programs = [
  {
    courseValue: 'One-Year MBA in Global Supply Chain Management (GSCM)',
    cardValue: '2026 One-Year MBA in Global Supply Chain Management (GSCM)',
    image: gscmbanner,
    title: <>MBA in Global Supply Chain Management</>,
    subtitle: 'A globally benchmarked One-Year MBA program for careers in supply chain leadership roles across industries.',
    appOpen: 'August 6, 2025, Wednesday',
    appClose: 'October 20, 2025, Monday',
    exam: 'CAT/GMAT/GRE',
    eligibility: 'Graduation & Minimum 3 Years Work Experience',
    borderColor: 'rgba(230, 75, 53, 1)',
    testDate: null,
    modeOfDelivery: 'Full-Time Residential',
    duration: '1 Year',
  },
  {
    courseValue: 'One-Year MBA in Digital Enterprise Management (DEM)',
    cardValue: 'One-Year MBA - Digital Enterprise Management (DEM)',
    image: demBanner,
    title: <>MBA in Digital Enterprise Management</>,
    subtitle: 'A One-Year MBA program designed to develop leaders in digital innovation and data-driven strategy.',
    appOpen: 'August 6, 2025, Wednesday',
    appClose: 'October 20, 2025, Monday',
    exam: 'CAT/GMAT/GRE',
    eligibility: 'Graduation & Minimum 3 Years Work Experience',
    borderColor: 'rgba(114, 44, 78, 1)',
    testDate: null,
    modeOfDelivery: 'Full-Time Residential',
    duration: '1 Year',
  },
  {
    courseValue: 'Executive Master of Business Administration (EMBA)',
    title: <>Executive MBA</>,
    image: banner,
    subtitle: "India's only IIM EMBA offering stage-wise certifications, multiple entry/exit options. Fully online coursework with campus immersion.",
    appOpen: 'To Be Announced',
    appClose: 'To Be Announced',
    exam: 'CAT/GMAT/GRE/IIMU Test',
    eligibility: 'Graduation & Minimum 3 Years Work Experience',
    borderColor: 'rgba(251, 192, 45, 1)',
    testDate: 'IIMU Test Dates: As announced',
    modeOfDelivery: 'Online with Campus Immersions',
    duration: '2 Years',
  },
  {
    courseValue: 'Executive Doctor of Philosophy (EPhD)',
    title: <>Executive PhD</>,
    image: banner,
    subtitle: 'A transformative doctoral journey for senior professionals—rooted in research, enriched by  International immersion, and designed for real-world impact.',
    appOpen: 'To Be Announced',
    appClose: 'To Be Announced',
    exam: 'CAT/ GMAT/ GRE /IIMU Test',
    eligibility: 'Graduations and/or Masters with Minimum 10 Years Work Experience',
    borderColor: 'rgba(48, 193, 255, 1)',
    testDate: 'IIMU Test Dates: As announced',
    modeOfDelivery: 'Online with Campus Residencies',
    duration: '3 to 5 Years',
  },
  {
    courseValue: 'Summer Program in Management (SPM)',
    title: <>Summer Program in Management</>,
    subtitle: 'A gateway for undergraduate students to explore the principles and possibilities of a career in management.',
    appOpen: 'To Be Announced',
    appClose: 'To Be Announced',
    exam: 'Not Applicable',
    image: banner,
    eligibility: 'Minimum Age of 18 Years with Completion of at Least First Semester of a Graduate-Level Course',
    borderColor: 'rgba(114, 44, 78, 1)',
    testDate: null,
    modeOfDelivery: 'Full-Time Residential',
    duration: '14 days',
  },
  {
    courseValue: 'Two-Year Master of Business Administration',
    title: <>Two-Year MBA (International Candidates)</>,
    subtitle: ' A flagship rigorous academic program, offering cutting-edge academic knowledge and leadership skills.',
    appOpen: 'To Be Announced',
    appClose: 'To Be Announced',
    exam: 'GMAT/GRE',
    eligibility: 'Graduation',
    borderColor: 'rgba(48, 97, 255, 1)',
    testDate: null,
    modeOfDelivery: 'Full-Time Residential',
    duration: '2 Years',
    image: banner,
  },
  {
    courseValue: 'Doctor of Philosophy (PhD)',
    title: <>Regular PhD</>,
    subtitle: 'A rigorous doctoral program focused on advanced research in chosen academic disciplines.',
    appOpen: 'To Be Announced',
    appClose: 'To Be Announced',
    exam: 'CAT/ GMAT/ GRE/ NET /JRF/ UPSC',
    eligibility: 'Graduations and/or Masters',
    borderColor: 'rgba(211, 47, 47, 1)',
    testDate: null,
    modeOfDelivery: 'Full-Time Residential',
    duration: '5 Years',
    image: banner,
  },
  {
    courseValue: 'Two-Year Master of Business Administration',
    title: <>Two-Year MBA (Domestic Candidates)</>,
    image: banner,
    subtitle: 'A flagship rigorous academic program, offering cutting-edge academic knowledge and leadership skills.',
    appOpen: 'To Be Announced',
    appClose: 'To Be Announced',
    exam: 'CAT',
    eligibility: 'Graduation',
    borderColor: 'rgba(56, 142, 60, 1)',
    testDate: null,
    modeOfDelivery: 'Full-Time Residential',
    duration: '2 Years',
  },
];

export const categoryOptions = [
  { value: '', label: 'Select', placeholder: true },
  { value: 'Program Details', label: 'Program Details' },
  { value: 'Eligibility & Selection Criteria', label: 'Eligibility & Selection Criteria' },
  { value: 'Admission Process', label: 'Admission Process' },
  { value: 'Fee Structure & Payment', label: 'Fee Structure & Payment' },
  { value: 'Accommodation & Campus Facilities', label: 'Accommodation & Campus Facilities' },
  { value: 'Placement & Career Support', label: 'Placement & Career Support' },
  { value: 'International Students / NRI / OCI Queries', label: 'International Students / NRI / OCI Queries' },
  { value: 'Academic Calendar & Joining Formalities', label: 'Academic Calendar & Joining Formalities' },
  { value: 'Location & Connectivity', label: 'Location & Connectivity' },
  { value: 'Withdrawal & Deferral Policy', label: 'Withdrawal & Deferral Policy' },
  { value: 'Miscellaneous / Other Queries', label: 'Miscellaneous / Other Queries' },
];

export const subCategoryMap = {
  'Program Details': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Curriculum structure', label: 'Curriculum structure' },
    { value: 'Pedagogy and faculty', label: 'Pedagogy and faculty' },
    { value: 'Specializations and electives', label: 'Specializations and electives' },
    { value: 'Global exposure opportunities', label: 'Global exposure opportunities' },
  ],
  'Eligibility & Selection Criteria': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Academic requirements', label: 'Academic requirements' },
    { value: 'Work experience norms', label: 'Work experience norms' },
    { value: 'Reservation policy', label: 'Reservation policy' },
    { value: 'CAP process', label: 'CAP process' },
  ],
  'Admission Process': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Offer timelines and deadlines', label: 'Offer timelines and deadlines' },
    { value: 'Offer acceptance procedure', label: 'Offer acceptance procedure' },
    { value: 'Required documents', label: 'Required documents' },
    { value: 'Waitlist movement', label: 'Waitlist movement' },
  ],
  'Fee Structure & Payment': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Program fee and components', label: 'Program fee and components' },
    { value: 'Payment deadlines and modes', label: 'Payment deadlines and modes' },
    { value: 'Refund policy', label: 'Refund policy' },
    { value: 'Financial aid or scholarships', label: 'Financial aid or scholarships' },
  ],
  'Accommodation & Campus Facilities': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Hostel options and allocation', label: 'Hostel options and allocation' },
    { value: 'Mess and dining', label: 'Mess and dining' },
    { value: 'Internet, sports, medical, etc.', label: 'Internet, sports, medical, etc.' },
  ],
  'Placement & Career Support': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Placement statistics', label: 'Placement statistics' },
    { value: 'Companies and roles', label: 'Companies and roles' },
    { value: 'Internship opportunities', label: 'Internship opportunities' },
    { value: 'Career support and mentorship', label: 'Career support and mentorship' },
  ],
  'International Students / NRI / OCI Queries': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Eligibility', label: 'Eligibility' },
    { value: 'Fee and admission process for international candidates', label: 'Fee and admission process for international candidates' },
    { value: 'Visa and travel-related queries', label: 'Visa and travel-related queries' },
  ],
  'Academic Calendar & Joining Formalities': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Term start date', label: 'Term start date' },
    { value: 'Orientation and induction', label: 'Orientation and induction' },
    { value: 'Pre-joining tasks', label: 'Pre-joining tasks' },
  ],
  'Location & Connectivity': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Travel to campus (nearest airport/station)', label: 'Travel to campus (nearest airport/station)' },
    { value: 'Local transport', label: 'Local transport' },
    { value: 'Climate and local living', label: 'Climate and local living' },
  ],
  'Withdrawal & Deferral Policy': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Withdrawal procedure', label: 'Withdrawal procedure' },
    { value: 'Refund timeline', label: 'Refund timeline' },
    { value: 'Deferral eligibility (if any)', label: 'Deferral eligibility (if any)' },
  ],
  'Miscellaneous / Other Queries': [
    { value: '', label: 'Select', placeholder: true },
    { value: 'Queries that don’t fit into any of the above categories', label: 'Queries that don’t fit into any of the above categories' },
    { value: 'Contact details for further support', label: 'Contact details for further support' },
  ],
};
